<template>
  <div class="toolbox-head" :class="{'hidden': selectedNum == 0}">
    <!--  -->
    <div class="header-wrap header-operate">
      <div class="header-operate-wrap">
        <div class="option-item" :class="{'disable': !options.selectAll}" @click="selectLoaded">
          <i :class="{'icon-select-loaded': selectedNum == loadedAllImageNum, 'icon-select-loaded-all': selectedNum != loadedAllImageNum}" :title="loadMsg"></i>
        </div>
        <div class="option-item" :class="{'disable': !options.move}" @click="openFolderSelector(true)">
          <i class="icon-move" :title="$t('operation.moveFiles')"></i>
        </div>
        <div class="option-item" :class="{'disable': !options.share}" @click="openShareBox">
          <i class="icon-share" :title="$t('operation.share')"></i>
        </div>
        <div class="option-item" :class="{'disable': !options.rename, 'hidden': mode != 'folder'}" @click="rename">
          <i class="icon-edit" :title="$t('operation.rename')"></i>
        </div>
        <div class="option-item" :class="{'disable': !options.pdf}" @click="togglePdfWindow(true)">
          <i class="icon-pdf" :title="$t('operation.exportPDF')"></i>
        </div>
        <div class="option-item" :class="{'disable': !options.download}" @click="downloadImages">
          <i class="icon-download" :title="$t('operation.download')"></i>
        </div>
        <div class="option-item" :class="{'disable': !options.delete}" @click="deleteFile">
          <i class="icon-delete" :title="$t('operation.delete')"></i>
        </div>
      </div>
      <div class="header-right">
        <i class="icon-close" @click="closeSelected"></i>
        <span>{{$t('operation.selected')}} {{selectedNum}} {{$t('list.items')}}</span>
      </div>
    </div>
    <!-- 图片移动的选择框 -->
    <folder-selector v-if="showFolderSelector" v-on:closeFolderSelector="openFolderSelector(false)" v-on:moveToFolder="moveToFolder(arguments[0])"></folder-selector>
    <!-- 图片分享Box -->
    <share-box v-if="showShareBox" :images="selectedImages" v-on:toCloseShareBox="closeShareBox"></share-box>
    <!-- 下载打包进度 -->
    <process-bar v-if="showProcessBar" :percentage="packageProcess" :text="loadingText"></process-bar>
    <!-- PDF的导出器 -->
    <pdf-exporter v-if="showPdfWindow" :pdfStatus="pdfProcessStatus" :percentage="pdfPercentage" v-on:closePdfWindow="togglePdfWindow(false)" v-on:confirmPDFAction="generatePDF(arguments[0])"></pdf-exporter>
    <!-- 确认，取消弹框 -->
    <two-btn-pop v-if="showTwoBtnPop" :popMainText="popMainText" v-on:closeTwoBtnPop="closeTwoBtnPop" v-on:deleteFn="deleteFn"></two-btn-pop>
    <input-pop v-if="showRenamePop" :folder="renameFolder" :title="$t('operation.rename')" v-on:closeInputPop="closeRenamePop"></input-pop>
    <one-btn-pop v-if="showMovePop" :oneBtnPopText="moveSuccessText" @closePop="closePop"></one-btn-pop>
  </div>
</template>

<script>
import ShareBox from './ShareBox'
import FolderSelector from './FolderSelector'
import ProcessBar from './ProcessBar'
import PdfExporter from './PdfExporter'
import TwoBtnPop from './TwoBtnPop'
import OneBtnPop from './OneBtnPop'
import InputPop from './InputPop'
import * as Config from 'common/script/config'
import HttpClient from 'common/script/http'
export default {
  name: 'imageToolbox',
  components: {
    ShareBox,
    FolderSelector,
    ProcessBar,
    PdfExporter,
    TwoBtnPop,
    InputPop,
    OneBtnPop
  },
  props: ['selectedNum', 'loadedAllImageNum', 'selectedImages', 'selectedFolders', 'mode'],
  data () {
    return {
      options: {
        selectAll: true,
        move: true,
        share: true,
        rename: true,
        pdf: true,
        download: true,
        delete: true
      },
      showShareBox: false,
      showFolderSelector: false,
      showProcessBar: false,
      packageProcess: 0,
      packageUrl: '',
      loadingText: this.$t('share.package'),
      packageTimer: null,
      showPdfWindow: false,
      pdfProcessStatus: 0, // 0: 设置选项，1: 导出中，2: 处理成功
      pdfPercentage: 0,
      pdfTimer: null,
      popMainText: '',
      showTwoBtnPop: false,
      showRenamePop: false,
      showMovePop: false,
      moveSuccessText: {
        top: this.$t('operation.msg'),
        main: this.$t('operation.moveFilesSuccess'),
        btn: this.$t('operation.confirm')
      },
      moveToFolderId: 0
    }
  },
  created () {
  },
  watch: {
    selectedFolders: function (newValue, oldValue) {
      // console.log(newValue)
      this.computeOptions()
    },
    selectedImages: function (newValue, oldValue) {
      this.computeOptions()
    }
  },
  computed: {
    loadMsg () {
      var msg = this.$t('operation.selectAllLoaded')
      if (this.selectedNum === this.loadedAllImageNum) {
        msg = this.$t('operation.deselectAll')
      }
      return msg
    },
    renameFolder () {
      var folder = null
      if (this.selectedFolders && this.selectedFolders.length > 0) {
        folder = this.selectedFolders[0]
      }
      // console.log('computed', folder)
      return folder
    }
  },
  methods: {
    computeOptions: function () {
      this.options.selectAll = true
      this.options.move = true
      this.options.share = true
      this.options.pdf = true
      this.options.download = true
      this.options.rename = true
      this.options.delete = true
      if (this.showFolderSelector) {
        this.disableAllFunction()
        return
      }
      // 文档分类模式
      if (this.mode === 'folder') {
        // 只有一个文件夹
        if (this.selectedFolders.length === 1 && this.selectedImages.length === 0) {
          this.options.rename = true
          // console.log(this.selectedFolders[0])
          // 空文件夹限制下载
          if (this.selectedFolders[0].fileCounts === 0) {
            this.options.download = false
          }
        } else {
          this.options.rename = false
        }
        if (this.selectedFolders.length === 0) {
          this.options.move = true
          this.options.share = true
          this.options.pdf = true
          this.options.download = true
          this.options.rename = false
        } else {
          this.options.move = false
          this.options.share = false
          this.options.pdf = false
        }
        if (this.selectedFolders.length > 0 && this.selectedImages.length > 0) {
          this.options.move = false
          this.options.share = false
          this.options.pdf = false
          this.options.download = false
        }
        if (this.selectedFolders.length > 1) {
          this.options.download = false
        }
      }
      // PDF的删除
      if (this.mode === 'pdf') {
        this.options.move = false
        this.options.share = false
        this.options.pdf = false
        this.options.download = false
        this.options.rename = false
      }
    },
    disableAllFunction: function () {
      this.options.selectAll = false
      this.options.move = false
      this.options.share = false
      this.options.pdf = false
      this.options.download = false
      this.options.rename = false
      this.options.delete = false
    },
    closeSelected: function () {
      this.showProcessBar = false
      this.showFolderSelector = false
      this.showPdfWindow = false
      this.pdfProcessStatus = 0
      clearInterval(this.pdfTimer)
      this.$emit('closeSelected')
    },
    selectLoaded: function () {
      if (!this.options.selectAll) return
      if (this.selectedNum === this.loadedAllImageNum) {
        this.closeSelected()
      } else {
        this.$emit('selectLoaded')
      }
    },
    openFolderSelector: function (flag) {
      if (!this.options.move) return
      this.showFolderSelector = flag
      if (flag) {
        this.disableAllFunction()
      } else {
        this.computeOptions()
      }
    },
    openShareBox: function () {
      if (!this.options.share) return
      this.showFolderSelector = false
      this.showShareBox = true
    },
    closeShareBox: function () {
      this.showShareBox = false
    },
    moveToFolder: function (folderId) {
      // console.log('------', folderId)
      if (folderId === '') {
        this.showFolderSelector = false
        this.computeOptions()
        return
      }
      this.moveToFolderId = folderId
      var selectedId = []
      for (var i = 0; i < this.selectedImages.length; i++) {
        selectedId.push(this.selectedImages[i].id)
      }
      var selectedIdStr = selectedId.join(',')
      HttpClient.postData(Config.APP_HOST + '/v1/file/move', {
        u_id: Config.cookieGet(Config.COOKIE_KEY.U_ID),
        dirId: folderId,
        fileIds: selectedIdStr
      }, this).then((response) => {
        // console.log(response)
        if (response.code === Config.R_CODE.SUCCESS) {
          this.showMovePop = true
        }
      })
    },
    closeProcessBar: function () {
      this.showProcessBar = false
    },
    downloadImages: function () {
      if (!this.options.download) return
      this.disableAllFunction()
      this.showFolderSelector = false
      this.showProcessBar = true
      this.packageProcess = 0
      var selectedId = []
      for (var i = 0; i < this.selectedImages.length; i++) {
        selectedId.push(this.selectedImages[i].id)
      }
      selectedId = selectedId.join(',')
      var dirId = ''
      if (this.selectedFolders && this.selectedFolders[0]) {
        dirId = this.selectedFolders[0].id
      }
      HttpClient.postData(Config.APP_HOST + '/v1/file/batchDownload', {
        u_id: Config.cookieGet(Config.COOKIE_KEY.U_ID),
        fileIdStrs: selectedId,
        dirId: dirId
      }, this).then((response) => {
        // console.log(response)
        if (response.code === Config.R_CODE.SUCCESS) {
          var key = response.body.redisKey
          this.packageUrl = response.body.downloadUrl
          var thisObj = this
          this.packageTimer = setInterval(function () {
            thisObj.getPackageProcess(key)
          }, 1000)
        }
      })
    },
    getPackageProcess: function (key) {
      HttpClient.postData(Config.APP_HOST + '/v1/file/batchDownloadProgress', {
        u_id: Config.cookieGet(Config.COOKIE_KEY.U_ID),
        redisKey: key
      }, this).then((response) => {
        // console.log(response)
        if (response.code === Config.R_CODE.SUCCESS) {
          var status = response.body.split(':')
          if (status[0] === 'download') {
            this.packageProcess = Math.round(status[1] / 4)
          } else if (status[0] === 'compress') {
            this.packageProcess = 25 + Math.round(status[1] / 2)
          } else if (status[0] === 'upload') {
            this.packageProcess = 75 + Math.floor(status[1] / 4)
          }
          if (this.packageProcess >= 100) {
            clearInterval(this.packageTimer)
            this.computeOptions()
            this.closeSelected()
            var tempThis = this
            setTimeout(function () {
              tempThis.showProcessBar = false
              window.location.href = tempThis.packageUrl
            }, 100)
          }
        }
      })
    },
    togglePdfWindow: function (show) {
      if (!this.options.pdf) return
      this.showPdfWindow = show
      if (!show) {
        this.pdfProcessStatus = 0
      }
    },
    generatePDF: function (pdfSetting) {
      var thisObj = this
      var ossKeys = []
      for (var i = 0; i < this.selectedImages.length; i++) {
        ossKeys.push(this.selectedImages[i].bigOssKey)
      }
      ossKeys = ossKeys.join(',')
      HttpClient.postData(Config.APP_HOST + '/v2/pdf/generate', {
        u_id: Config.cookieGet(Config.COOKIE_KEY.U_ID),
        ossKeys: ossKeys,
        fileName: pdfSetting.fileName,
        pdfType: pdfSetting.pdfType,
        qualityType: pdfSetting.qualityType,
        horizontal: pdfSetting.horizontal
      }, this).then((response) => {
        // console.log(response)
        if (response.code === Config.R_CODE.SUCCESS) {
          this.pdfProcessStatus = 1
          this.pdfPercentage = 0
          this.pdfTimer = setInterval(function () {
            thisObj.getGeneratePDFProcess(response.body.id, response.body.randomKey)
          }, 1000)
        }
      })
    },
    getGeneratePDFProcess: function (pdfId, randomKey) {
      HttpClient.postData(Config.APP_HOST + '/v2/pdf/generate/result', {
        u_id: Config.cookieGet(Config.COOKIE_KEY.U_ID),
        id: pdfId,
        randomKey: randomKey
      }, this).then((response) => {
        // console.log(response)
        if (response.code === Config.R_CODE.SUCCESS) {
          if (response.body.url && response.body.url !== '') {
            this.pdfPercentage = 100
            this.pdfProcessStatus = 2
            clearInterval(this.pdfTimer)
          } else {
            this.pdfPercentage = Math.round(response.body.percent)
            if (response.body.percent >= 100) {
              this.pdfProcessStatus = 2
              clearInterval(this.pdfTimer)
            }
          }
        } else if (response.code === Config.R_CODE.PDF_PREPARING) {
          this.pdfProcessStatus = 1
          this.pdfPercentage = 0
          // console.log('准备中....')
        }
      })
    },
    closeTwoBtnPop: function () {
      this.showTwoBtnPop = false
    },
    deleteFile: function () {
      if (!this.options.delete) return
      this.showFolderSelector = false
      this.showTwoBtnPop = true
      this.popMainText = this.$t('operation.delete') + '?'
    },
    deleteFn: function () {
      var selectedId = []
      if (this.mode === 'pdf') {
        var pdfIds = []
        if (this.selectedImages) {
          for (var p = 0; p < this.selectedImages.length; p++) {
            pdfIds.push(this.selectedImages[p].id)
          }
        }
        pdfIds = pdfIds.join(',')
        HttpClient.postData(Config.APP_HOST + '/v2/pdf/delete', {
          u_id: Config.cookieGet(Config.COOKIE_KEY.U_ID),
          fileIds: pdfIds
        }, this).then((response) => {
          if (response.code === Config.R_CODE.SUCCESS) {
            this.showTwoBtnPop = false
            this.$emit('deleteSelectedImages')
            this.closeSelected()
          }
        })
      } else {
        if (this.selectedImages) {
          for (var i = 0; i < this.selectedImages.length; i++) {
            selectedId.push(this.selectedImages[i].id)
          }
        }
        selectedId = selectedId.join(',')
        var dirIds = []
        if (this.selectedFolders) {
          for (var j = 0; j < this.selectedFolders.length; j++) {
            dirIds.push(this.selectedFolders[j].id)
          }
        }
        dirIds = dirIds.join(',')
        HttpClient.postData(Config.APP_HOST + '/v1/file/delete', {
          u_id: Config.cookieGet(Config.COOKIE_KEY.U_ID),
          fileIds: selectedId,
          dirIds: dirIds
        }, this).then((response) => {
          if (response.code === Config.R_CODE.SUCCESS) {
            this.showTwoBtnPop = false
            this.$emit('deleteSelectedImages')
            this.closeSelected()
          }
        })
      }
    },
    rename: function () {
      if (!this.options.rename) return
      this.showFolderSelector = false
      this.showRenamePop = true
    },
    closeRenamePop: function () {
      this.showRenamePop = false
      this.closeSelected()
    },
    closePop: function () {
      this.showMovePop = false
      var selectedId = []
      for (var i = 0; i < this.selectedImages.length; i++) {
        selectedId.push(this.selectedImages[i].id)
      }
      this.$emit('moveToFolderFinished', selectedId, this.moveToFolderId)
      this.closeSelected()
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.toolbox-head
  width 100%
  height 50px
  line-height 50px
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  color #3d3d3d
  z-index 999
  &.hidden
    display none
  .header-wrap
    &.header-operate
      width 100%
      height 100%
      background-color #3d3d3d
      position relative
      .header-operate-wrap
        display flex
        width 480px
        height 100%
        margin 0 auto
        flex-direction row
        justify-content space-around
        align-items center
        .option-item
          position relative
          display flex
          width 80px
          height 50px
          flex-direction column
          justify-content space-around
          align-items center
          cursor pointer
          &.disable
            color #999999
            i
              color #999999
              cursor pointer
          &.hidden
            display none
          i
            display block
            width 22px
            height 22px
            font-size 22px
            color #fff
            line-height 22px
            cursor pointer
            transition all 0.2s ease-in
      .header-right
        height 100%
        position absolute
        top 0
        left 22px
        font-size 16px
        color #fff
        .icon-close
          font-size 12px
          vertical-align baseline
          margin-right 6px
          cursor pointer
@keyframes rotate
  0%
    transform rotate(0deg)
  100%
    transform rotate(45deg)
</style>



// WEBPACK FOOTER //
// src/components/Et/ImageToolbox.vue